import compose from "recompose/compose";
import {injectIntl} from "react-intl";
import {connect} from "react-redux";
import {getUserGroupRank} from "../../pages/Profile/selectors";
import setDisplayName from "recompose/setDisplayName";
import {SimpleDropdown} from "../forms/BasicFormFields/SImpleDropdown";
import {DropdownInput} from "../forms/BasicFormFields";
import {getGroups} from "../../resources/selectors";

export const groupsUserMayAddTo = (state, props) => {
    const allGroups = getGroups(state.resources);
    const userGroupRank = getUserGroupRank(state);

    // users can only add other users to their group or
    // "below", so e.g. interns cannot add others to Root.
    return allGroups
        .filter(group => group.rank >= userGroupRank);
};

const connectGroups = connect((state, props) => {

    let groups = groupsUserMayAddTo(state, props).map(group => ({
        text: props.intl.formatMessage({id: `resource.types.Group.name.${group.name}`}),
        value: group.id
    }))

    groups = [{text: '—', value: 'none'}].concat(groups)

    return {
        options: groups
    };
});

export const GroupDropdown = compose(
    injectIntl,
    connectGroups,
    setDisplayName('GroupDropdown')
)(DropdownInput);

export const MultiGroupDropdown = compose(
    injectIntl,
    connectGroups,
    setDisplayName('MultiGroupDropdown')
)(SimpleDropdown);


// WEBPACK FOOTER //
// ./public/components/composites/UserGroupDropdown.jsx